module.exports = __webpack_public_path__ + "./img-cathy_5664184f1d1bdb2bb44ad91fd4d02abf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-cathy.png
// module id = 461
// module chunks = 0